const styles = theme => ({
  Title: {
    fontWeight: '600',
    marginBottom: '5px',
  },
  textHolder: {
    padding: '11px 0px 9px',
    fontSize: '18px',
    color: theme.palette.secondary.light,
    '& p': {
      color: theme.palette.primary.darkGrey,
      fontSize: '14px',
    },
  },
  avatar: {
    height: '64px',
    width: '64px',
    marginRight: '16px',
  },
  switchProListHolder: {
    overflow: 'auto',
    maxHeight: '520px',
    paddingRight: '20px',
    '&::-webkit-scrollbar-track': {
      background: '#F8F8F8',
      borderRadius: '0 0 12px 0',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      background: '#F8F8F8',
      borderRadius: '0 0 12px 0',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CED1D6',
      borderRadius: '50rem',
    },
  },
  switchProListitem: {
    paddingTop: '18px',
    paddingBottom: '18px',
    borderTop: '1px solid #EBEEF3',
    display: 'flex',
    '&:nth-child(1)': {
      border: 'none',
    },
    '& div': {
      whiteSpace: 'normal',
    },
    '&:hover': {
      background: 'transparent',
    },
  },
  icon: {
    minWidth: 'auto',
    flexShrink: '0',
  },
  primaryText: {
    fontWeight: '500',
  },
  activeProfile: {},
  subTextadge: {
    '& span': {
      position: 'static',
      transform: 'none',
      marginLeft: '5px',
    },
  },
});

export default styles;
